import { render, staticRenderFns } from "./MenuDesktop.vue?vue&type=template&id=2d20bb31&"
import script from "./MenuDesktop.vue?vue&type=script&lang=js&"
export * from "./MenuDesktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports